import type { ReactNode } from 'react';

export interface CollapsibleHeaderProps {
  /** How small the header shrinks: 0.5 = 50% of original height (default: 0.5) */
  ratio?: number;
  /** Optional background layer behind the shrinking content (e.g. blurred image) */
  background?: ReactNode;
  /** Sharp content that scales down on scroll */
  children: ReactNode;
}

/**
 * Marker component that signals to ResponsiveSheet that the header should
 * collapse on scroll. This component never renders — ResponsiveSheet detects
 * it via `__isCollapsibleHeader` and reads its props to set up the collapse
 * behavior internally.
 *
 * In modal mode (desktop), children are rendered directly with no collapse.
 *
 * @example
 * ```tsx
 * <ResponsiveSheet
 *   header={
 *     <CollapsibleHeader
 *       ratio={0.5}
 *       background={<Img src={url} className="blur-sm brightness-50" />}
 *     >
 *       <div className="aspect-video">
 *         <SharpMedia />
 *       </div>
 *     </CollapsibleHeader>
 *   }
 * >
 * ```
 */
export function CollapsibleHeader(_: CollapsibleHeaderProps): null {
  return null;
}

CollapsibleHeader.__isCollapsibleHeader = true as const;
